<script setup>
import { ref } from 'vue'
const options = ['RTL', 'Eigenlijk', 'Streaming', 'AI', '2025', 'Winst', 'Strategie', 'Focus', 'Natuurlijk']

const selectedOption = ref(null)
const selectOption = (option) => {
  selectedOption.value = option
}

const submitted = ref(false)
const submit = async () => {
  await fetch(`https://qmusic.nl/webform/forms/1139/submissions.js`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      webform_submission: {
        answers_attributes: {
          0: {
            webform_question_id: 7689,
            content: selectedOption.value,
          },
        },
      },
    }),
  })
  submitted.value = true
}
</script>

<template>
  <div class="container">
    <img src="./assets/qmusic-hvw-review_preview.jpg" alt="Logo" />
    <h1>Het Verboden Woord</h1>
    <p v-if="!submitted">
      Erik wist ons de laatste edities van de Review Preview steeds te misleiden. Van mysterieuze boodschappen en
      verraad tijdens onze eigen versie van ‘De Verraders’, tot een zoektocht door het onafgewerkte Mediavaert vorig
      jaar tijdens de ‘Bestemming X’-editie.

      <br />
      <br />
      Hoog tijd om de rollen om te draaien en het Erik wat moeilijker te maken…

      <br />
      <br />
      Welk woord mag Erik absoluut niet gebruiken tijdens zijn presentatie op de Review Preview van 13 februari? Laat
      het ons hieronder weten voor 12 februari!

      <br />
      <br />
      PS: hou het zeker nog geheim voor Erik, dan is de verrassing extra groot!
    </p>
    <p v-if="submitted">
      Yes! Jouw stem is binnen.
      <br /><br />
      Je ontdekt tijdens de Review Preview welk woord Erik niet mag zeggen.
      <br /><br />
      PS: hou het zeker nog geheim voor Erik, dan is de verrassing extra groot!
    </p>
    <div v-if="!submitted" class="options">
      <button
        v-for="option in options"
        :key="option"
        :class="{ selected: selectedOption === option }"
        @click="selectOption(option)"
      >
        {{ option }}
      </button>
    </div>

    <button v-if="!submitted" :disabled="!selectedOption" class="submit-button" @click="submit">Bevestig keuze</button>
  </div>
</template>

<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100vh;
  width: 100vw;
  overflow-x: hidden;
  max-width: 600px;
}

img {
  width: 100vw;
  max-width: 600px;
  margin-bottom: 20px;
}

.options {
  display: grid;
  max-width: 600px;
  flex-wrap: wrap;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;

  button {
    padding: 10px;
    width: 100%;
    box-sizing: border-box;
    background-color: #333;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-family: 'Cervo';
    text-transform: uppercase;
    color: white;
    border: 2px solid #333;
    font-size: 1.5rem;
  }

  button:hover {
    background-color: #555;
  }

  button.selected {
    background-color: #777;
    border: 2px solid white;
  }
}

.submit-button {
  margin: 20px;
  width: calc(100% - 40px);
  padding: 10px 20px;
  background-color: #333;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-family: 'Cervo';
  text-transform: uppercase;
  color: white;
  font-size: 1.5rem;

  &:disabled {
    background-color: #555;
    cursor: not-allowed;
  }
}

h1,
h2 {
  font-family: 'Cervo';
  text-transform: uppercase;
  color: white;
  margin: 0px;
}

p {
  font-family: 'Qarla';
  padding: 0 10px;
  color: white;
}
</style>
